import React from 'react';
import {Link} from "react-router-dom";

import TechnologySmallIcon from './technologySmallIcon.js'
import CveTitle from './cveTitle.js'
import Pagination from './pagination.js'
import {_printDate, _printShortFullDate, _printNumber} from '../helpers/helpers.js'
import {RtPage} from '../../../server/routes/route-types.js'

import {RtCVEInfo} from '../../../server/routes/cve.js'

// interface CVETechnologyInfo {
// 	URL: string;
// 	ShortName: string;
// 	Icon: string;
// }

// type CVE = RtCVEInfo; 

interface CVEListData {
	CVEs: RtCVEInfo[];
 	Pages?: RtPage[];
}

interface CVEListProps {
	data: CVEListData;
	list: RtCVEInfo[];
	title: string;
	subtitle?: string;
}

export default function CVEList({data, list, title, subtitle}: CVEListProps) {
	return (
	<>
		<h3>{title}</h3> 
		{subtitle} 
		<br/>    
		<br/>    
		<div className="table-outer table-rounded table-responsive-lg">
		<table className="table-custom table-custom-striped table-custom-primary  ">
			<thead>
			<tr>
				<th style={{width: '13%'}}>Published</th>
				<th style={{width: '17%'}}>CVE ID</th>
				<th style={{width: '18%'}}>Product</th> 				
				<th style={{width: '44%'}}>Title</th> 
				<th style={{width: '8%'}}>Websites</th>
			</tr>
			</thead>
			<tbody>
			{
				list.map((cve, indexKey) => {
					return (
						<CVERow cve={cve} key={indexKey}/>
					)
				})
			}	
			</tbody>
		</table>
		</div>
		<Pagination pages={data.Pages} />			
	</>
	)
}

interface CVERowProps {
	cve: RtCVEInfo;
	requireAuthentication?: boolean;
}

function CVERow({cve, requireAuthentication}: CVERowProps) {
	const techInfo = cve.CVETechnologyInfo;
	return (
		<>
		<tr>   		      
		<td>
				{_printShortFullDate(cve.Discovered)}
			</td>     
			<td>
				{cve.CVEId}
			</td>     
			<td>	  
				<Link 
					to={`/technology/${techInfo!.URL}`}
					className="link-hover" 
					title={techInfo!.ShortName} 
				>				
					<TechnologySmallIcon 
						technologyIcon={techInfo!.Icon} 
						technology={techInfo!.ShortName}
					/>
					{' '}{techInfo!.ShortName}
				</Link>                   						
			</td>			
			<td>	                     
				<Link 
					to={`/cve/${cve.CVEId}`} 
					className="link-hover" 
				>
					<CveTitle cve={cve} />
				</Link> 							
			</td>			

			<td>
				{_printNumber(cve.DomainCount)}
			</td>
		</tr>		
		</>
	)
}
		